import { api } from "@/services/api";
import { preferencesApi } from "@/services/preferencesApi";
import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({
  middleware: (m) => m().concat(api.middleware, preferencesApi.middleware),
  reducer: {
    [api.reducerPath]: api.reducer,
    [preferencesApi.reducerPath]: preferencesApi.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
